import { useEffect, useState } from "react";
import "@/App.css";
import { translations } from "./i18n";
import { Header } from "./components/Header";
import { Hero } from "./components/Hero";
import { Services } from "./components/Services";
import { Calculator } from "./components/Calculator";
import { WhyUs } from "./components/WhyUs";
import { Contact } from "./components/Contact";
import { Footer } from "./components/Footer";
import { FloatingCTA } from "./components/FloatingCTA";

function App() {
  const [lang, setLang] = useState(() => {
    if (typeof window === "undefined") return "en";
    return localStorage.getItem("cng_lang") || "en";
  });

  useEffect(() => {
    localStorage.setItem("cng_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const t = translations[lang];

  return (
    <div className="App min-h-screen bg-white font-body text-neutral-900 antialiased">
      <Header lang={lang} setLang={setLang} t={t} />
      <main>
        <Hero t={t} />
        <Services t={t} />
        <Calculator t={t} />
        <WhyUs t={t} />
        <Contact t={t} />
      </main>
      <Footer t={t} />
      <FloatingCTA t={t} />
    </div>
  );
}

export default App;
